var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogokaruna(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 260",
    width: 240,
    height: 260,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "blade",
    d: "M0,0 C-6.6,-14.399999999999999 -11,-31.200000000000003 -11,-48 C-11,-71.76 -4.95,-87.39999999999999 0,-92 C4.95,-87.39999999999999 11,-71.76 11,-48 C11,-31.200000000000003 6.6,-14.399999999999999 0,0 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,168) scale(1.05)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#blade",
    transform: "rotate(-34) translate(-16,4) scale(0.58)",
    fill: "#0E3B36",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("use", {
    href: "#blade",
    transform: "rotate(30) translate(17,5) scale(0.74)",
    fill: "#0E3B36",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("use", {
    href: "#blade",
    transform: "rotate(-2) scale(1.0)",
    fill: "#C9A24B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 6,
    r: 6.5,
    fill: "#C9A24B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogokaruna);
export default __webpack_public_path__ + "static/media/logo.karuna.e710fe06bce2b9e7e5b509d3e97223ea.svg";
export { ForwardRef as ReactComponent };